import { render, staticRenderFns } from "./ParcelEditProduct.vue?vue&type=template&id=b6cf3740&"
import script from "./ParcelEditProduct.vue?vue&type=script&lang=js&"
export * from "./ParcelEditProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports